// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Zo-z","breadcrumbForward":"_o-z","breadcrumbBack":"ap-z","selected":"bp-z"};